import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { format } from "date-fns";
import type { UserTeam } from "@/types/teams";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/**
 * Check if a user belongs to a specific team
 * Handles both string team IDs and UserTeam objects
 */
export function userHasTeam(teams: (string | UserTeam)[], teamId: string): boolean {
  return teams.some(t => typeof t === 'string' ? t === teamId : t.teamId === teamId);
}

export function formatDate(date: string | Date, formatStr: string = "MMM dd, yyyy"): string {
  try {
    const dateObj = typeof date === "string" ? new Date(date) : date;
    return format(dateObj, formatStr);
  } catch (error) {
    console.error("Error formatting date:", error);
    return String(date);
  }
}
